module.exports = __webpack_public_path__ + "img/Socio.42add10d.png";